module.exports = __webpack_public_path__ + "img/tinkoff.5a100f32.png";